<template>
  <div class="animated fadeIn">
    
    <!-- <b-row class="justify-content-center" >
      <b-col md="10" lg="8" xl="5">
        <b-card>
          <div slot="header">Report - Customer Order Summary/Forecast 
          </div>
            <b-input-group >
                <b-input-group-prepend><label style="width:107px !important;">Customer/Group</label></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.customer" placeholder="Customer/Group"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group >
                <b-input-group-prepend><label style="width:107px !important;">Date range</label></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl2" type="date" ></b-form-input>
            </b-input-group >
            <b-row class="justify-content-center mt-1">
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
        </b-col>
    </b-row> -->



    <b-card >
      <div slot="header">Report - Customer Order Summary/Forecast  
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="custgroup" @change="reloaddata"></b-form-select> 
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label style="width:130px !important;">Customer</label></b-input-group-prepend>
              <b-form-input v-model="tblData.customer" placeholder="Customer"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group>
              <b-input-group-prepend><label style="width:130px !important;">Order Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
          <b-input-group >
                <b-input-group-append><b-button class="btn btn-secondary ml-2" style="width:110px !important;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-append><b-button class="btn btn-success ml-2" style="width:110px !important;" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
            </b-input-group >
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            sticky-header="500px"
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
        <template v-slot:cell(tanggal)="data">
          <span v-if="(data.item.tanggal)">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
          </span>
        </template>
        <template v-slot:cell(orderdate)="data">
          <span v-if="(data.item.orderdate)">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
          </span>
        </template>
         <template v-slot:cell(unitprice)="data">
          {{data.item.unitprice | numFormat}}
        </template>
        <template v-slot:cell(qtyOrder)="data">
          {{data.item.qtyOrder | numFormat}}
        </template>
        <template v-slot:cell(qtyDeliver)="data">
          {{data.item.qtyDeliver | numFormat}}
        </template>
        <template v-slot:cell(qtyChecker)="data">
          {{data.item.qtyChecker | numFormat}}
        </template>
        <template v-slot:cell(qtyReceipt)="data">
          {{data.item.qtyReceipt | numFormat}}
        </template>
        <template v-slot:cell(qtyRetur)="data">
          {{data.item.qtyRetur | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferIn)="data">
          {{data.item.qtyTransferIn | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferOut)="data">
          {{data.item.qtyTransferOut | numFormat}}
        </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading> 
        <!-- <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
        </b-modal>  -->

        <!-- <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
        </b-modal>  -->



        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer" :customer_group="tblData.customer_group" ></lku-customer>
        </b-modal>        

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
import lkuCustomer from "../lookup/lkuCustomerGroup";
import procure from "../../apis/bakeryorder";
import report from "../../apis/bakeryreport";
import customer from "../../apis/bakerycustomer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {Loading, lkuCustomer},
  mixins: [validationMixin],
  // validations: {
  //       forecastcustomer: {
  //           customer_id: { required },
  //           tgl1: { required },
  //           tgl2: { required }
  //       },
  // }, 
  data() {
    return {
      showDelConfirm: false,
      showFrmCustomer:false,
      //forecastcustomer:{customer_id:'', tgl1:'', tgl2:''},
      lkuCustomerShow:false,
      isLoading:false,
      custgroup:[
            { value: '', text: '-- ALL--' }
        ],

      tblFields: [
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            stickyColumn: true,
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty Order",
            thStyle: "width:80px",
            sortable: true
          },
      ],
      model:{},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        headcategory:null,
        //vendor_id:'3B1998E0-E708-11EB-B7EC-F37BF40624E8', //default vendor: ASA FOOD
        //vendorinfo: 'ASAFOOD | PT Asa Foodenesia Abadi',
        // customer_id:'3081D270-24F3-11EC-9EA9-9377A8860922', //default customer/group: AEON Head Office
        // customer: 'AEON Head Office | C0081',
        customer_group:'',
        customer_id:'',
        customer: '',
        tgl1:moment().format("YYYY-MM-DD"),
        tgl2:moment().format("YYYY-MM-DD"),
        status:''
      },
      limit:15,
      pagination: false,
      items:[],
      lkuItemShow:false,
      itemList:{},
        uanguser: this.$store.state.user.matauang,
      showFilter:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      headCategories:[], itemCategories:[],



    };
  },
  computed: {
    invalidFcCustomer() {
      this.$v.forecastcustomer.$touch();
      return this.$v.forecastcustomer.$invalid;
    },
  },

  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }, 
  },

  created: async function(){
    try {
      const [custgroup] = await Promise.all([
                customer.group()
                ]) ;
            if(custgroup){
                 custgroup.map((data)=>{
                    this.custgroup.push({
                        value:data.value,
                        text:data.text
                    });
                });
            }
    } catch (error) {
        this.isLoading = false;
          console.log('error : ', error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
    }

  },

  methods: {
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.orderlist) {
            this.tblData[key] = filter.orderlist[key];
            filtered=true;
        }
        this.tblFields= [
          {
            key: "partnumber",
            label: "Item No.",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            stickyColumn: true,
            sortable: true
          },
        ];
        
        let awal = moment(this.tblData.tgl1, 'YYYY-MM-DD');
        let akhir = moment(this.tblData.tgl2, 'YYYY-MM-DD').add(1, 'days');
        while (awal.isBefore(akhir, 'day')) {
            this.tblFields.push({
                key: `QTot${awal.format('YYYYMMDD')}`,
                label: `TOTAL ${awal.format('DDMMMYYYY')}`,
                sortable: true
            });
            awal.add(1, 'days');
        }

        let list =[];
        if (filtered === true) {
          if (!(filter.orderlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.orderlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  list = await report.fcCustomer(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              list = await report.fcCustomer(this.tblData);
              // //console.log("#list: ", list);
              //   list.map(data=>{
              //     // console.log("#this.tblData.tgl1: ", this.tblData.tgl1);
              //     // console.log("#this.tblData.tgl2: ", this.tblData.tgl2);
              //     // console.log("#data qty: ", data.quantity);
              // });
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    async reloaddata(val) {
      // this.isLoading = true;
      this.tblData.customer_group = val;
      this.tblData.customer_id = '';
      this.tblData.customer = '';
      // this.isLoading = false;
    },
    selectItem(record,index) {
      if ((this.tblData) && (this.tblData._rowVariant)) {
          delete this.tblData._rowVariant;
      }
      this.tblData = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemno = '';
        this.tblData.item =  '';
        this.tblData.tgl1 = '';
        this.tblData.tgl2 = '';
        this.tblData.customer_id = '';
        this.tblData.customer = '';
        this.tblData.customer_group = '';
        // this.refresh();
    }, 
    itemChange: function () {
        this.tblData.itemno = '';
    },
    saveFilter() {
      const keys = ['tgl1', 'tgl2','itemno', 'item'];
      let filtered = false;
      const orderlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              orderlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          orderlist.page=this.tblData.page;
          orderlist.limit=this.tblData.limit;
          orderlist.sortBy=this.tblData.sortBy;
          orderlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.orderlist=orderlist;
          this.$store.commit("filter", filter);
      }
    }, 

    onSelectLkuCustomer: async function (_selected) {
        this.tblData.customer_id = _selected.customer_id;
        this.tblData.CustCode = _selected.CustCode;
        this.tblData.CustName = _selected.CustName;
        this.tblData.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        this.lkuCustomerShow=false;
    },    
    exportxls: async function() {
      // if (this.invalidFcCustomer) {
      //     console.log('validation : ', this.$v.forecastcustomer);
      //     console.log('frmdata obj : ',this.forecastcustomer);
      //     toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      // } else {
          try {
              this.isLoading=true;
              this.tblData.tgl1 = moment(this.tblData.tgl1).format('YYYY-MM-DD');
              this.tblData.tgl2 = moment(this.tblData.tgl2).format('YYYY-MM-DD');
              const response = await procure.exportFcCustomer(this.tblData);
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'customer_order_summary.xlsx');
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
      //}
    },   
    close(){
      router.push("home");
    },    
  }
};
</script>
